import {useTheme} from '@mui/material';

interface QuantityPickerIconsProps {
  width?: string;
  height?: string;
  fillBg?: string;
  fillRect?: string;
  disabled?: boolean;
  viewBox?: string;
  rx?: string;
}

export const DeleteIconWithBg = ({
  width = '32',
  height = '32',
  viewBox = '0 0 32 32 ',
  fillBg = '#FFFFFF',
  fillRect = '#F22643',
  disabled = false,
  rx = '16'
}: QuantityPickerIconsProps) => {
  const theme = useTheme();

  const _fillBg = !disabled ? fillBg : theme.palette.grey[400];
  const _fillRect = !disabled ? fillRect : theme.palette.grey[200];
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width={width} height={width} rx={rx} fill={_fillRect} />
      <path
        d="M23.7534 9.65694H20.229V8.95206C20.229 8.39122 20.0062 7.85335 19.6096 7.45677C19.213 7.0602 18.6751 6.8374 18.1143 6.8374H13.885C13.3241 6.8374 12.7863 7.0602 12.3897 7.45677C11.9931 7.85335 11.7703 8.39122 11.7703 8.95206V9.65694H8.2459C8.05895 9.65694 7.87966 9.73121 7.74747 9.8634C7.61528 9.99559 7.54102 10.1749 7.54102 10.3618C7.54102 10.5488 7.61528 10.7281 7.74747 10.8603C7.87966 10.9925 8.05895 11.0667 8.2459 11.0667H8.95079V23.7547C8.95079 24.1286 9.09932 24.4871 9.3637 24.7515C9.62808 25.0159 9.98666 25.1644 10.3606 25.1644H21.6387C22.0126 25.1644 22.3712 25.0159 22.6356 24.7515C22.9 24.4871 23.0485 24.1286 23.0485 23.7547V11.0667H23.7534C23.9403 11.0667 24.1196 10.9925 24.2518 10.8603C24.384 10.7281 24.4583 10.5488 24.4583 10.3618C24.4583 10.1749 24.384 9.99559 24.2518 9.8634C24.1196 9.73121 23.9403 9.65694 23.7534 9.65694ZM13.1801 8.95206C13.1801 8.76511 13.2544 8.58582 13.3866 8.45363C13.5187 8.32144 13.698 8.24717 13.885 8.24717H18.1143C18.3012 8.24717 18.4805 8.32144 18.6127 8.45363C18.7449 8.58582 18.8192 8.76511 18.8192 8.95206V9.65694H13.1801V8.95206ZM21.6387 23.7547H10.3606V11.0667H21.6387V23.7547ZM14.5899 14.5911V20.2302C14.5899 20.4172 14.5156 20.5965 14.3834 20.7287C14.2512 20.8609 14.0719 20.9351 13.885 20.9351C13.698 20.9351 13.5187 20.8609 13.3866 20.7287C13.2544 20.5965 13.1801 20.4172 13.1801 20.2302V14.5911C13.1801 14.4042 13.2544 14.2249 13.3866 14.0927C13.5187 13.9605 13.698 13.8863 13.885 13.8863C14.0719 13.8863 14.2512 13.9605 14.3834 14.0927C14.5156 14.2249 14.5899 14.4042 14.5899 14.5911ZM18.8192 14.5911V20.2302C18.8192 20.4172 18.7449 20.5965 18.6127 20.7287C18.4805 20.8609 18.3012 20.9351 18.1143 20.9351C17.9274 20.9351 17.7481 20.8609 17.6159 20.7287C17.4837 20.5965 17.4094 20.4172 17.4094 20.2302V14.5911C17.4094 14.4042 17.4837 14.2249 17.6159 14.0927C17.7481 13.9605 17.9274 13.8863 18.1143 13.8863C18.3012 13.8863 18.4805 13.9605 18.6127 14.0927C18.7449 14.2249 18.8192 14.4042 18.8192 14.5911Z"
        fill={_fillBg}
      />
    </svg>
  );
};
